import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.706 0H1.882C.838 0 .01.89.01 2L0 16c0 1.11.838 2 1.882 2h19.824c1.045 0 1.882-.89 1.882-2V2c0-1.11-.837-2-1.882-2zm0 16H1.882V7h19.824v9zm0-12H1.882V2h19.824v2z",
		fillRule: "nonzero",
		fill: "inherit"
	})
});
export default SvgCreditCard;
